import Vue from 'vue';
import VueRouter from 'vue-router';
import Cookie from 'js-cookie';

import Vue2Filters from 'vue2-filters';
import DurationFilter from './filters/duration.js';

import Root from './components/Root.vue';

import App from './App.js';
import EventBus from './EventBus.js';
import routes from './routes.js';
import { api } from './API.js';
import SessionHelper from './SessionHelper.js';

import browserSupport from './browserSupport.js';
import PristineSeekbarFix from './standalone/seekbar-fix.js';
window.addEventListener('DOMContentLoaded', (e) => {
    console.log('fixing');
    for (let el of document.querySelectorAll('[data-seekbar-fix]')) {
        console.log('fixing', el);
        if (!el.dataset.seekbarFix) {
            PristineSeekbarFix(el);
        }
    }
});



// Mobile redirect
if (window.innerWidth < 800) {
    window.location = '/mobile';
}

if (!browserSupport.isBrowserSupported()) {
    Vue.use(VueRouter);
    Vue.use(Vue2Filters);

    Vue.filter('duration', DurationFilter);

    const router = new VueRouter({
        routes,
        base: '/app/',
        mode: 'history',
        scrollBehavior(to, from, savedPosition) {
            if (savedPosition) {
                return savedPosition;
            }
            return { x: 0, y: 0 };
        }
    });

    router.beforeEach((to, from, next) => {
        if (to.meta.title) {
            document.title = to.meta.title
        }
        next();
    });



    Root.router = router;
    const root = new Vue(Root).$mount('[data-app=pristine-player]');
    const app = new App(root);


    EventBus.on('auth.success', (e) => {
        if (e.data.api_key) {
            SessionHelper.setAPIKey(e.data.api_key);

        }
    });

    EventBus.on('auth.triggerLogout', (e) => {
        SessionHelper.forgetAPIKey();
        window.location.href = "/app";
    });


    var apiKey = SessionHelper.getAPIKey();
    if (apiKey) {
        api.authenticate(apiKey, null, 'api_key', function afterAuth(ok) {
            console.log('auth mode', 'api_key');
            console.log('auth ok', ok);
        });
    } else {
        api.authenticate(null, null, 'anon', function afterAuth(ok) {
            console.log('auth mode', 'anon');
            console.log('auth ok', ok);
        });
    }

    app.init();
}



// WEBPACK FOOTER //
// ./src/main.js